import { useState, Fragment } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';

import { formatTime } from '~utils/common.utils';
import {
  getTransportStatusLabel,
  getStatusLabel,
  progressToBeadStates,
} from '~utils/status.utils';
import { Bead } from '~ui-kit';
import { mediumGap, largeGap, blue, textGrey } from '~theme';

const lightBlue = '#dcdfec';
const grey = '#f2f2f2';
const lightGrey = '#9E9E9E';

const HistoryAccordion = ({ patientTransport, progress }) => {
  const [open, setOpen] = useState(true);

  // Assuming states are in order, active state should be the latest one with
  // timestamp
  const activeState = _.findLast(progress, s => s.time !== null);

  const beadStates = progressToBeadStates(progress);

  return (
    <Wrapper>
      <Container open={open} onClick={() => setOpen(!open)}>
        <Header>
          <Arrow icon={!open ? faChevronDown : faChevronUp} />
          Tilauksen vaiheet
        </Header>
      </Container>
      {open &&
        _.zip(beadStates, progress).map(([beadState, state], i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={i}>
            <Phase active={state.orderStatus === activeState.orderStatus}>
              <Bead state={beadState} i={i + 1} />
              <StatusLabel
                old={
                  i <
                  progress.findIndex(
                    s => s.orderStatus === activeState.orderStatus
                  )
                }
              >
                {patientTransport
                  ? getTransportStatusLabel(state.orderStatus)
                  : getStatusLabel(state.orderStatus)}
                {state.name ? (
                  <>
                    <br />
                    <Driver>{state.name ? `${state.name}` : null}</Driver>
                  </>
                ) : null}
              </StatusLabel>
              <Time active={state.orderStatus === activeState.orderStatus}>
                {state.time ? formatTime(state.time, true) : 'Odottaa'}
              </Time>
            </Phase>
            {i < progress.length - 1 && <VLine />}
          </Fragment>
        ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-bottom: 16px;
  background-color: ${grey};
`;

const Base = styled.div`
  padding: 16px;
`;

const Container = styled(Base)`
  border-radius: 4px 4px ${p => (p.open ? '0 0' : '4px 4px')};
  cursor: pointer;
`;

const Header = styled.div`
  font-size: 16px;
  color: var(--primaryColor);
  display: flex;
  align-items: center;
`;

const Phase = styled.div`
  display: flex;
  align-items: center;
  gap: ${mediumGap};

  background-color: ${props => (props.active ? lightBlue : 'initial')};
  border-radius: 32px;

  min-height: 64px;
  padding: ${mediumGap} ${largeGap};
  margin: 0 ${mediumGap};
`;

const StatusLabel = styled.div`
  font-weight: 600;
  font-size: 16px;

  color: ${props => (props.old ? lightGrey : blue)};
`;

const Driver = styled.div`
  color: ${textGrey};
  font-size: 14px;
  font-weight: 400;
`;

const Arrow = styled(FontAwesomeIcon)`
  width: 16px;
  margin-right: 12px;
`;

const Time = styled.span`
  margin-left: auto;

  color: ${props => (props.active ? textGrey : lightGrey)};
  font-weight: 400;
  font-size: 14px;
`;

const VLine = styled.div`
  &::after {
    content: '';

    border: 1px;
    border-style: solid;
    border-color: black;

    padding: 18px 0;
    margin-left: 51px;
  }
  height: 0;
  width: 0;
`;

export default HistoryAccordion;
